import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=3a7744a9&scoped=true"
import script from "./helpCenter.vue?vue&type=script&lang=js"
export * from "./helpCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7744a9",
  null
  
)

export default component.exports